mutation UpdateContentPoll($id: ID!, $input: ContentPollScheduleInput!) {
  updateContentPoll(id: $id, input: $input) {
    id
    trigger
    offsetSeconds
    startsAt
    autoCloseSeconds
    status
  }
}
